import { useState, useEffect } from "react"
import "./UserGrid.scss"
import { User } from "../../../utils/models/User"
import { format } from "date-fns"
import { useTranslation } from "react-i18next"
import { Spinner } from "react-bootstrap"
import { UserAdminRoles } from "../../../utils/const"
import { ISelectOptions } from "../../../utils/interfaces/ISelectOptions"
import { ROLES } from "aw-consts"
import { DataGrid } from "aw-data-grid"
import { createColumnHelper } from "@tanstack/react-table"

const UserGrid = (props: { userRole: number; users: User[]; onEditClick: (c: User) => void; onDeleteClick: (c: User) => void; loading: boolean, query:any, setQuery:any }) => {
    const { t } = useTranslation()
    const [users, setUsers] = useState<User[]>(props.users)
    const [allRolesObj] = useState<ISelectOptions[]>(UserAdminRoles())
    const columnHelper = createColumnHelper<User>()
    const columns = [
        columnHelper.accessor("name", {
            header: () => t("Name"),
            cell: (info) => info.getValue(),
        }),
        columnHelper.accessor("surname", {
            header: () => t("Surnames"),
            cell: (info) => info.getValue(),
        }),
        ...(props.userRole !== ROLES.Administrator
            ? [
                  columnHelper.accessor("email", {
                      header: () => t("Email"),
                      cell: (info) => info.getValue(),
                  })
              ]
            : [
                  columnHelper.accessor("company_str", {
                      header: () => t("Company"),
                      cell: (info) => info.getValue(),
                  }),
                  columnHelper.accessor("numberOfConnections", {
                      header: () => t("NumberOfConnections"),
                      cell: (info) => info.getValue(),
                      enableColumnFilter: false
                  })
              ]),
        columnHelper.accessor("last_conection", {
            header: () => t("LastConection"),
            cell: (info) => format(new Date(info.getValue()), "dd/MM/yyyy HH:mm:ss"),
            enableColumnFilter: false
        }),
        columnHelper.display({
            id: "actions",
            header: "",
            cell: (info) => (
                <div className='text-end'>
                    <button onClick={() => props.onDeleteClick(info.row.original)} className='btn-Simple text-danger'>
                        <i className='bi bi-trash'></i>
                    </button>
                </div>
            ),
            enableSorting: false,
            enableColumnFilter: false
        })
    ]
    useEffect(() => {
        setUsers(props.users.sort((a, b) => a.iduser - b.iduser))
    }, [props.users])

    return (
        <div className='p-2 rounded-1' id='gridUserContainer'>
            {props.loading ? (
                <div className='text-center pt-5'>
                    <Spinner animation='border' variant='success' />
                </div>
            ) : users.length > 0 ? (
                <div className='table-responsive scrollUsers'>
                    <DataGrid data={users} columns={columns} onRowClick={(user) => props.onEditClick(user)}  filtersPlaceholder={t('Search')} globalFilter={props.query} onGlobalFilterChange={props.setQuery} />
                </div>
            ) : (
                <p className='text-center'>{t("NoUsers")}</p>
            )}
        </div>
    )
}

export default UserGrid
